<!--  -->
<template>
  <div class="SampleList">
    <h1>{{ Sample_title }}</h1>
    <ul class="sampleUl">
      <li v-for="(item, index) in sampleList" :key="index">
        <div class="sampleBox">
          <img class="imgControl" :src="item.src" />
        </div>
        <p>{{ item.title }}</p>
      </li>
    </ul>

    <ul class="sampleUl">
      <li v-for="(item, index) in kuaidiList" :key="index">
        <div class="sampleBox">
          <img class="imgControl" :src="item.src" />
        </div>
      </li>
    </ul>

    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="allPage"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      Sample_title: "",

      sampleList: [],
      kuaidiList: [],

      //   分页
      allPage: 20, // 总页数
      pageSize: 12, // 每页条数
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //切换第几页
    handleCurrentChange(val) {
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: v.cid,
          page: { val }.val,
          show_num: 12,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.sampleList = [];
            if (obj.data) {
              that.allPage = obj.data[0].total_nums;
              $.each(obj.data, function (i, k) {
                var linshi = {
                  title: k.title,
                  src: k.pic_f,
                };
                that.sampleList.push(linshi);
              });
            }
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var that = this;
    var v = parseUrl();
    $.ajax({
      url: "/index.php?s=Home/Api/get_data",
      type: "get",
      datatype: "json",
      data: {
        act: "article_list",
        category_id: v.cid,
        page: 1,
        show_num: 12,
      },
      success: function (ret) {
        var obj = JSON.parse(ret); //json数据转为数组
        if (obj.code == "0000") {
          that.Sample_title = obj.yj_name;
          that.sampleList = [];
          if (obj.data) {
            that.allPage = obj.data[0].total_nums;
            $.each(obj.data, function (i, k) {
              var linshi = {
                title: k.title,
                src: k.pic_f,
              };
              that.sampleList.push(linshi);
            });
          }
        }
      },
      error: function (err) {
        console.log("ajax错误");
      },
    });

    $.ajax({
      url: "/index.php?s=Home/Api/get_data",
      type: "get",
      datatype: "json",
      data: {
        act: "article_list",
        category_id: 19,
      },
      success: function (ret) {
        var obj = JSON.parse(ret); //json数据转为数组
        if (obj.code == "0000") {
          if (obj.data) {
           console.log(obj.data);
           $.each(obj.data, function (i, k) {
              var kuaidi = {
                src: k.pic_f,
              };
              that.kuaidiList.push(kuaidi);
            });
          }
        }
      },
      error: function (err) {
        console.log("ajax错误");
      },
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
function parseUrl() {
  var url = location.href;
  var i = url.indexOf("?");
  if (i == -1) return;
  var querystr = url.substr(i + 1);
  var arr1 = querystr.split("&");
  var arr2 = new Object();
  for (i in arr1) {
    var ta = arr1[i].split("=");
    arr2[ta[0]] = ta[1];
  }
  return arr2;
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.SampleList {
  width: 100%;
  padding: 100px 9.25rem 110px;
  h1 {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    color: #39404a;
  }
  .sampleUl {
    margin-top: 60px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    li {
      width: 24%;
      margin-top: 15px;
      .sampleBox {
        width: 100%;
        height: 328px;
        background: #f7f7f7;
      }
      p {
        font-size: 1.2rem;
        text-align: center;
        font-weight: 400;
        color: #666666;
        margin: 26px 0;
      }
    }
    li:not(:nth-child(4n)) {
      margin-right: calc(4% / 3);
    }
  }

  .page {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 110px;
  }
  .page >>> .active {
    background-color: #5fbb68 !important;
  }
  .page >>> li:not(.active):hover {
    color: #5fbb68 !important;
  }
  .page >>> .btn-prev {
    width: 35px;
    height: 35px;
  }
  .page >>> .btn-next {
    width: 35px;
    height: 35px;
  }
  .page >>> .el-pager li {
    width: 35px;
    height: 35px;
    font-size: 0.9rem;
    line-height: 35px;
  }
}
@media screen and (max-width: 1200px) {
  .SampleList {
    padding: 40px 10px;
    .sampleUl {
      justify-content: space-between;
      li {
        width: 49%;
        margin: 0;
        .sampleBox {
          width: 100%;
          height: auto;
        }
        p {
          font-size: 1rem;
        }
      }
      li:not(:nth-child(4n)) {
        margin-right: 0;
      }
    }
    .page {
      margin-top: 40px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Sample/SampleList.vue